<template>
  <div id="footer" style="height:150px">
  	<div class="d-flex align-items-center justify-content-between" style="height:60px;padding-left:26%;padding-right:26%">
  		<a href="#" class="fz14">兴趣百科使用手册</a>
  		<a href="#" class="fz14">投诉建议</a>
  		<a href="#" class="fz14">兴趣百科微博</a>
  		<a href="#" class="d-flex align-items-center" style="position: relative;">
        <div class="fz14" v-on:mouseenter="show()" v-on:mouseleave="hide()">兴趣百科公众号</div>
        <img src="../../assets/img/index/circleManager.jpg" style="width:90px;height:90px;margin-left:10px;position: absolute;z-index: 10;top:-35px;left:100px" v-if="codeImgShow"/>
      </a>

  	</div>
  	<div class="fz12 text-center mar-top10" style="color:#999">兴趣百科是国内领先的兴趣社群平台，在这里，能快速发现你感兴趣的圈子；发掘天赋，种下兴趣的种子，逐步走向成功！</div>
  	<div class="fz12 text-center mar-top15" style="color:#999"><a class="fz12" href="https://beian.miit.gov.cn" target="_blank">粤ICP备19078440号-1</a> © 兴趣百科（东莞）文化传媒科技有限公司 电话：0769-85898319</div>
  </div>
</template>

<script>
  export default {

    data () {
      return {
        codeImgShow:false
      }
    },
    mounted(){//页面加载后，调用接口数据
      // this.getData(0);

    },
    methods:{
      show:function(){//鼠标移入页脚公众号，显示出公众号二维码
        this.codeImgShow=true
      },
      hide:function(){//鼠标移出页脚公众号，显示出公众号二维码
        this.codeImgShow=false
      }
    },
  }

</script>

<style>
</style>
<style lang="less">
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  #footer a{color:#fff}
</style>a



// WEBPACK FOOTER //
// src/pages/pc/footer.vue